import { tv } from '@/common/theme/tv.config';

export const styles = tv({
  slots: {
    root: '',
    label: 'whitespace-nowrap lowercase leading-none text-neutral10',
  },
  variants: {
    size: {
      md: {
        root: 'min-h-[2rem] rounded-full px-sm py-xs',
        label: 'text-xs leading-none',
      },
      lg: {
        root: 'min-h-[3rem] rounded-full px-md py-sm',
        label: 'text-sm leading-none',
      },
    },
    emphasis: {
      soft: '',
      normal: '',
    },
    status: {
      success: '',
      warning: '',
      error: '',
      info: '',
      disabled: '',
    },
  },
  compoundVariants: [
    {
      emphasis: 'normal',
      status: 'info',
      class: { root: 'bg-systemInfo20' },
    },
    {
      emphasis: 'normal',
      status: 'warning',
      class: { root: 'bg-systemWarning20' },
    },
    {
      emphasis: 'normal',
      status: 'error',
      class: { root: 'bg-systemError20' },
    },
    {
      emphasis: 'normal',
      status: 'success',
      class: { root: 'bg-systemSuccess20' },
    },
    {
      emphasis: 'normal',
      status: 'disabled',
      class: { root: 'bg-systemDisabled20' },
    },
    {
      emphasis: 'soft',
      status: 'info',
      class: { root: 'bg-systemInfo10', label: 'text-systemInfo' },
    },
    {
      emphasis: 'soft',
      status: 'warning',
      class: { root: 'bg-systemWarning10', label: 'text-systemWarning' },
    },
    {
      emphasis: 'soft',
      status: 'error',
      class: { root: 'bg-systemError10', label: 'text-systemError' },
    },
    {
      emphasis: 'soft',
      status: 'success',
      class: { root: 'bg-systemSuccess10', label: 'text-systemSuccess' },
    },
    {
      emphasis: 'soft',
      status: 'disabled',
      class: { root: 'bg-systemDisabled10', label: 'text-neutral20' },
    },
  ],
})();
